// Cleave.js is used to detect credit card types.
// Supported types:
// amex, mastercard, visa, diners, discover, jcb,
// dankort, instapayment, uatp, mir, unionPay

export default {
  // TODO: Add missing icons
  amex: require("@/assets/credit-cards/amex.png"),
  // dankort: "",
  diners: require("@/assets/credit-cards/diners.png"),
  discover: require("@/assets/credit-cards/discover.png"),
  // instapayment: "",
  jcb: require("@/assets/credit-cards/jcb.png"),
  mastercard: require("@/assets/credit-cards/mastercard.png"),
  // mir: "",
  // uatp: "",
  // unionPay: "",
  visa: require("@/assets/credit-cards/visa.png")
};
